import React from 'react'

export default function Left() {
    return (
        <>
            <dic className="contLeft">
                <h3 className='leftD'>upto 90% discount on products</h3>
                <img src='img/bbd.jpg' alt="" className='leftImg1' />
            </dic>
        </>
    )
}
